module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_vm._v("The courage we desire and prize")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("is not the courage to die decently,")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("but to live manfully.")]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_vm._v("—T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMAS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARLYLE")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("God will not look you over for")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("medals, degrees or diplomas, but")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("for scars.")]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_vm._v("—E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LBERT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBBARD")])]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("You say that a good cause will")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("even sanctify war! I tell you,")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("it is the good war that sanctifies every cause!")]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_vm._v("—F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIEDRICH")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IETZSCHE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0